import { comp } from "../func/comp";
import { $iter, iterator } from "../iterator";
import { cat } from "./cat";
import { mapIndexed } from "./map-indexed";
export function mapcatIndexed(...args) {
    return ($iter(mapcatIndexed, args, iterator) ||
        comp(mapIndexed(args[0], args[1]), cat()));
}
